"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  props: {
    data: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatSeconds: function formatSeconds(seconds) {
      var hrs = Math.floor(seconds / 3600);
      var mins = Math.floor(seconds % 3600 / 60);
      return "".concat(hrs.toString().padStart(2, '0'), ":").concat(mins.toString().padStart(2, '0'));
    },
    formatDate: function formatDate(date) {
      return date ? _moment.default.utc(date).format('DD/MM/YYYY') : '—-';
    },
    formatType: function formatType(type) {
      var map = {
        SICK_LEAVE: 'Problemas de Saúde',
        MEDICAL_CERTIFICATE: 'Atestado Médico',
        VACATION: 'Férias',
        OFF_DAY: 'Folga',
        AUTHORIZED: 'Autorizado',
        OTHER_REASONS: 'Outro'
      };
      return map[type] || type;
    }
  }
};